import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { mapAppOpation, restaurantGroups } from "../../data";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { LogoutIcon, MapGreenPinIcon, MapRedPinIcon } from "../../icon/icon";
import { reqToForceUserLogout } from "../../store/slice/userSlice";
import { useDispatch } from "react-redux";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [restaurantGroupOptions, setrestaurantGroupOptions] = useState([]);
  const [values, setValues] = useState({
    date: new Date(),
    app: null,
    group: null,
    branch: null,
    address: "",
    city: "",
    lat: null,
    lng: null,
  });

  useEffect(() => {
    const createdGroups =
      JSON.parse(localStorage.getItem("restaurantGroups")) || [];
    setrestaurantGroupOptions([...restaurantGroups, ...createdGroups]);
  }, []);

  const handleDateChange = (date) => {
    setValues({ ...values, date: moment(date).format("YYYY-MM-DD") });
  };

  const handleGroupChange = (group) => {
    setValues({
      ...values,
      group,
      branch: null,
      address: "",
      city: "",
      lat: null,
      lng: null,
    });
  };

  const handleBranchChange = (branch) => {
    if (branch.value === "all") {
      setValues({
        ...values,
        branch,
        address: "",
        city: "",
        lat: null,
        lng: null,
      });
      return;
    }
    const selectedBranch = values.group?.branches?.find(
      (b) => b.value === branch.value
    );
    setValues({
      ...values,
      branch,
      address: selectedBranch?.address || "",
      city: selectedBranch?.city || "",
      lat: selectedBranch?.lat,
      lng: selectedBranch?.lng,
    });
  };

  const defaultCenter = { lat: 14.5995, lng: 120.9842 }; // Manila
  const mapCenter =
    values.lat && values.lng
      ? { lat: values.lat, lng: values.lng }
      : defaultCenter;
  const containerStyle = { width: "100%", height: "100%" };

  const selectedBranches =
    values.branch?.value === "all"
      ? values.group?.branches?.filter((b) => b.value !== "all") || []
      : values.branch
      ? [values.group?.branches?.find((b) => b.value === values.branch.value)]
      : [];

  const handleUserLogout = () => {
    dispatch(reqToForceUserLogout({ data: "", dispatch }));
  };

  return (
    <div className="bg-white h-100">
      <Row className="h-100">
        <Col
          md={4}
          lg={3}
          className="h-100 d-flex flex-column p-0 border-left border-dark"
        >
          <div className="comman-form py-3 overflow-auto pe-2">
            <div className="form-group mb-3 pb-4 border-bottom border-dark ps-3">
              <div className="form-label">
                <span>Date</span>
              </div>
              <div className="form-input-box">
                <ReactDatePicker
                  id="date"
                  name="date"
                  dateFormat="yyyy-MM-dd"
                  selected={values.date ? new Date(values.date) : null}
                  onChange={handleDateChange}
                  onKeyDown={(e) => e.preventDefault()}
                  className="form-control datepicker"
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="ps-3">
              <div className="form-group mb-3">
                <div className="form-label">
                  <span>App</span>
                </div>
                <div className="form-input-box">
                  <Select
                    id="role"
                    name="role"
                    value={values?.role}
                    options={mapAppOpation}
                    className={`tc-custom-select-2 w-100 mb-0`}
                    classNamePrefix="select"
                    placeholder="Select..."
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">
                  <span>Restaurant Group </span>
                </div>
                <div className="form-input-box">
                  <Select
                    id="group"
                    name="group"
                    value={values?.group}
                    options={restaurantGroupOptions}
                    onChange={handleGroupChange}
                    className={`tc-custom-select-2 w-100 mb-0`}
                    classNamePrefix="select"
                    placeholder="Select..."
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">
                  <span>Branch </span>
                </div>
                <div className="form-input-box">
                  <Select
                    id="branch"
                    name="branch"
                    value={values?.branch}
                    options={values.group?.branches || []}
                    onChange={handleBranchChange}
                    className={`tc-custom-select-2 w-100 mb-0`}
                    classNamePrefix="select"
                    placeholder="Select..."
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">
                  <span>Complete Address</span>
                </div>
                <div className="form-input-box">
                  <textarea
                    rows={3}
                    value={values?.branch?.address || ""}
                    className="tc-card-static-input"
                    disabled
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">
                  <span>City</span>
                </div>
                <div className="form-input-box">
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={values?.branch?.city || ""}
                    className="tc-card-static-input"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="mt-auto p-2 rcm-logout border-top border-dark"
            role="button"
            onClick={() => handleUserLogout()}
          >
            {LogoutIcon} Logout
          </div>
        </Col>

        <Col md={8} lg={9} className="p-0 ps-3 position-relative rcm-map">
          <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={mapCenter}
              zoom={12}
            >
              {selectedBranches.map(
                (branch, index) =>
                  branch && (
                    <Marker
                      key={index}
                      position={{ lat: branch.lat, lng: branch.lng }}
                      title={branch.label}
                      icon={{
                        url: MapRedPinIcon,
                        scaledSize: new window.google.maps.Size(40, 40),
                        anchor: new window.google.maps.Point(20, 40),
                      }}
                    />
                  )
              )}
            </GoogleMap>
          </LoadScript>

          <div className="d-flex align-items-center gap-2 justify-content-center rcm-map-button">
            <button className="orange-btn rcm-btn">Map</button>
            <button className="red-btn rcm-btn">Graph</button>
            <button className="green-btn rcm-btn">Report</button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
